import { atom } from "recoil";
export const chatUserAtom = atom({
  key: "chat-user",
  default: null,
});
